var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotification)?_c('div',{staticClass:"notification",class:_vm.notificationClass},[(_vm.isTranslated)?[_vm._v(_vm._s(_vm.getTranslatedText(_vm.message)))]:_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }